// extracted by mini-css-extract-plugin
module.exports = {"backPageWrap":"backSearch_backPageWrap__2mfcw","linkWrap":"backSearch_linkWrap__3YGKt","container":"backSearch_container__3CXSZ"};